import React, {useContext} from 'react';
import {AppCtx} from "../../../AppCtx";
import {FaMusic, FaSlash} from 'react-icons/fa';

/** @deprecated Hidden from the simplified catalogue menu. */
export default () => {
  const {areChordsVisible, setAreChordsVisible} = useContext(AppCtx);
  return <div style={{cursor:'pointer',position:'relative'}} 
              onClick={()=>setAreChordsVisible(!areChordsVisible)}
              role="button" tabIndex={0}
              aria-label={areChordsVisible ? "Ukryj akordy" : "Pokaż akordy"}
              title={areChordsVisible ? "Ukryj akordy" : "Pokaż akordy"}>
    <FaMusic style={{color:areChordsVisible?'var(--menu-icon-inactive-color)':'var(--menu-icon-color)'}}/>
    {!areChordsVisible && <FaSlash style={{position:'absolute',top:0,left:0,color:'var(--text-error)'}}/>}
  </div>;
};
